import React, { useEffect, useState } from "react";
import { HeroProducts } from '../../components';
import { Banner } from '../../components';
import { InnerLink } from '../../components';
import { Loader } from '../../components';
import { ProdsCarousel } from '../../components';
import { MockupGrid } from '../../components';
import { ArticleProducts } from '../../components';
import { CircleFollow } from '../../components';
import { BaseUrl } from "../../config";


const ProductsContainer = (props) => {

  const [imgsGallery, setImgsGallery] = useState([])
  const [createLine, setCreateLine] = useState(false)
  const [isFetching, setIsFetching] = useState(true)
  let arrayLoad = [];
  document.title = "Retail Solutions by Invrsion"
  const quotesArray = [
    {
      "quote": "Invrsion is one of the most innovative and forward thinking VR research partners that we have ever worked with.",
      "name": "Narith Panh",
      "company": "Ipsos",
      "position": "Vice President Marketing US"
    },
    {
      "quote": "Invrsion is one of the most innovative and forward thinking VR research partners that we have ever worked with.",
      "name": "Narith Panh",
      "company": "Ipsos",
      "position": "Vice President Marketing US"
    },
    {
      "quote": "Invrsion is one of the most innovative and forward thinking VR research partners that we have ever worked with.",
      "name": "Narith Panh",
      "company": "Ipsos",
      "position": "Vice President Marketing US"
    },
    {
      "quote": "Invrsion is one of the most innovative and forward thinking VR research partners that we have ever worked with.",
      "name": "Narith Panh",
      "company": "Ipsos",
      "position": "Vice President Marketing US"
    }
  ];


  const heroImgLeft = require('../../assets/hero-prod-left.png');
  const heroImgRight = require('../../assets/hero-prod-right.png');
  arrayLoad = [
    heroImgLeft,
    heroImgRight,
  ]
  useEffect(() =>{
   
    fetch(`${BaseUrl}/page?key=invrsion&slug=products-index`, {
      method: 'GET'
    })
    .then(response => {
      return response.json()
      
    }).then((res) => {
      setImgsGallery(res.data.sliderSketchfab);

      setIsFetching(false)

      setTimeout(() => setCreateLine(true), 500)
    })

    
  }, [])

  
  
  return (
    <React.Fragment>
      <HeroProducts 
        title="Fulfill your business with Full Reality solutions" 
        bgColor="linear-gradient(180deg, #003D2B 0%, #4C796C 100%)"
        imgLeft={heroImgLeft}
        imgRight={heroImgRight}>
      </HeroProducts>
      <div className="column--quote-wrap">
        <p className="preset-13">FULL REALITY MEETS BUSINESS</p>
        <h6 className="big--title">We bring the best of the real and digital worlds together to enhance the shopping experience of your enterprise through Full Reality.</h6>
      </div>
      <div className="side--quote-wrap">
        <p className="preset-9 side--title">It all starts with 3D</p>
        <p className="preset-9 side--text">Every one of our Full Reality experiences begin with creating 3D Digital Twins of your inventory. Adding another dimension to your product range and allowing your customers to play with the truest-to-life renders on your digital touchpoints.</p>
      </div>
      {
        imgsGallery.length > 0 &&
          <ProdsCarousel imgs={imgsGallery} >
            <h6 className="big--title below--carousel center">Explore where our 3D Digital Twins can take your business</h6>
            <p className="preset-9">Add another dimension to your online <span>shopping experience</span></p>
          </ProdsCarousel>
      }
      
      <MockupGrid iframeUrl="41c7254381ae443c88d3ad0eefe994da" zoom="50" />
      {
        createLine &&
        <CircleFollow />
      }
      <ArticleProducts 
        align="align-right" 
        title="3D Commerce"
        link="/products/3d-commerce"
        articleText="Enhance your current e-commerce and digital solutions with renders that are more immersive, in-depth, and detailed than anything you or your customers have ever seen online."
      />
      <ArticleProducts 
        align="align-left" 
        introText="Learn how to optimize your store’s"
        introHighlight="shopping experience"
        img={require('../../assets/prod-hub-article/retail-store-2400x1472.jpg')}
        imgSize="figure--11"
        title="Retail Store Virtualization"
        link="/products/retail-store-virtualization"
        articleText="Perfect the layout, product placement, and mockups of your current retail space by virtualizing, simulating, and optimizing the shopping experience. Giving you all the insights you need to succeed."
      />
      <ArticleProducts 
        align="align-right"
        introText="Design the most immersive and easily accessible"
        introHighlight="shopping experience"
        img={require('../../assets/prod-hub-article/virtual-showroom-1960x1200.jpg')}
        imgSize="figure--9"
        title="Virtual Showroom"
        link="/products/virtual-showroom"
        articleText="Build the space that best fits your business by creating a fully immersive VR experience for your clients. Adding breathtaking digital context to whatever content you want to showcase."
      />
      <ArticleProducts 
        align="align-left" 
        introText="Push the boundaries of your in-store"
        introHighlight="shopping experience"
        img={require('../../assets/prod-hub-article/store-in-store-1550x930.jpg')}
        imgSize="figure--7"
        title="Store In-Store"
        link="/products/store-in-store"
        articleText="Make the most of your current space by adding another dimension to your product catalog. Immersing your in-store clients in an out-of-store experience."
      />
      <ArticleProducts 
        align="align-right"
        introText="Don’t wait to gain the advantages of the next-gen"
        introHighlight="shopping experience"
        img={require('../../assets/prod-hub-article/v-commerce-1070x660.jpg')}
        imgSize="figure--5"
        title="V-Commerce"
        classToAdd="line-end-trigger"
        link="/products/v-commerce"
        articleText="Join the retail revolution by giving your customers a fully immersive online shopping experience from discovery to drop-shipping. Creating a virtual retail space where all of your products come to life right before your customers' eyes."
      />

      <div className="paragraph--col-wrap ">
        <div className="paragraph--col-big">
          <h5 className="big--title">
            Explore the industries that we upgrade with our Full Reality solutions          
          </h5>
        </div>
      </div>
      
      <InnerLink />
      <Banner text="Intrigued? Let’s have a chat." route="/contact-us" copyRoute="Reach out" />
      <Loader isFetching={true} arrayLoad={arrayLoad}/>
    </React.Fragment>
  );
};

export default ProductsContainer;
